/* eslint-disable complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import Row from '@tcp/core/src/components/common/atoms/Row';
import BundleProductListLoaderContext from '@tcp/core/src/components/features/browse/BundleProduct/molecules/BundleProductListView/views/BundleProductListContext';
import BundleProductListLoadingComponent from '@tcp/core/src/components/features/browse/BundleProduct/molecules/BundleProductListView/views/BundleProductListViewSkeleton.view';
import withStyles from '../../../../../../common/hoc/withStyles';
import LoaderSkelton from '../../../../../../common/molecules/LoaderSkelton';
import styles, {
  StyledPaginatedGridSkeleton,
  StyledPriceContainer,
  StyledLoaderSkeleton,
} from '../styles/BundleProductSkeletonNewDesign.style';
import {
  getImagesToDisplay,
  getMapSliceForColorProductId,
} from '../../../../ProductListing/molecules/ProductList/utils/productsCommonUtils';
import Col from '../../../../../../common/atoms/Col';
import ProductDetailImage from '../../../../../../common/molecules/ProductDetailImage';
import { IMG_DATA } from '../../../views/config';
import PromoPDPBanners from '../../../../../../common/organisms/PromoPDPBanners';
import SocialConnect from '../../../../../../common/organisms/ProductImages/views/SocialConnect.view';

const BundleCommonStructure = () => {
  return (
    <>
      <div className="product-overview-detail-wrapper">
        <div className="product-title-price-wrapper">
          <div className="product-title">
            <LoaderSkelton />
          </div>

          <div className="product-price">
            <LoaderSkelton />
          </div>
        </div>
      </div>
      <div className="product-add-to-bag">
        <LoaderSkelton />
      </div>
    </>
  );
};
const bundleProductGridComponent = (productLength) => {
  return [...Array(productLength)].map(() => (
    <StyledPaginatedGridSkeleton>
      <LoaderSkelton className="grid-image-skeleton" />
      <div className="grid-price-skeleton">
        <LoaderSkelton width="100px" />
        <LoaderSkelton width="32px" />
      </div>

      <LoaderSkelton className="grid-promo-skeleton" />
      <LoaderSkelton className="grid-title-skeleton" />
    </StyledPaginatedGridSkeleton>
  ));
};

const BundleDetailsSkeletonStructure = (
  className,
  isCombinedKitsEnabled,
  carryForwardImgUrlValue
) => {
  const thumbnailList = [];
  for (let itr = 0; itr < 5; itr += 1) {
    thumbnailList.push(
      <div className="thumbnail-list">
        <LoaderSkelton />
      </div>
    );
  }
  return (
    <div className={className}>
      <Row fullBleed className="breadcrumb-container">
        <Col colSize={{ small: 6, medium: 8, large: 12 }} className="breadcrum-wrapper" />
      </Row>
      <Row fullBleed className="product-detail-skeleton-wrapper">
        <Col colSize={{ small: 6, medium: 3, large: 4 }} className="main-bundle-image nonretrieved">
          {isCombinedKitsEnabled ? (
            <ProductDetailImage
              imageUrl={carryForwardImgUrlValue}
              isZoomEnabled={false}
              imageConfig={IMG_DATA?.imgConfig}
              isOutfitPage={false}
              fromPLPPage={false}
            />
          ) : (
            <LoaderSkelton className="product-skeleton-img" />
          )}
        </Col>
        <Col colSize={{ small: 6, medium: 4, large: 8 }} className={'main-bundle-description'}>
          {BundleCommonStructure()}
        </Col>
        <Col colSize={{ small: 6, medium: 8, large: 12 }} className={'plp-grid'}>
          {bundleProductGridComponent(12)}
        </Col>
      </Row>
    </div>
  );
};

const getSingleImageObj = (uniqueId) => {
  const imagePath = `${uniqueId?.split('_')[0]}/${uniqueId}`;
  return [
    {
      isShortImage: false,
      isOnModalImage: false,
      iconSizeImageUrl: imagePath,
      listingSizeImageUrl: imagePath,
      regularSizeImageUrl: imagePath,
      bigSizeImageUrl: imagePath,
      superSizeImageUrl: imagePath,
    },
  ];
};

const BundleProductSkeletonNewDesign = ({
  breadcrumb,
  currentProduct,
  primaryBrand,
  className,
  retrievedProductInfo,
  fromPLPPage,
  currencyAttributes,
  isHideOriginalPrice,
  isCombinedKitsEnabled,
  carryForwardImgUrlValue,
  topPromos,
  currentView,
  errorMessages,
  isBundlePageRedesign,
  isOutfitPage,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  if (!retrievedProductInfo) {
    return BundleDetailsSkeletonStructure(
      className,
      isCombinedKitsEnabled,
      carryForwardImgUrlValue
    );
  }
  const {
    name,
    colorFitsSizesMap,
    uniqueId,
    imagesByColor,
    bundleProductsCount,
    lowOfferPrice,
    highOfferPrice,
    lowListPrice,
    highListPrice,
    imageConfigWithoutDPR = '',
  } = retrievedProductInfo;
  const bundleProductsLength = (bundleProductsCount && bundleProductsCount?.length) || 4;

  const currentColorEntry = getMapSliceForColorProductId(colorFitsSizesMap, uniqueId) || {};
  let imagesToDisplay = getImagesToDisplay({
    imagesByColor,
    curentColorEntry: currentColorEntry,
    isAbTestActive: false,
    isFullSet: true,
    excludeShortImage: false,
  });

  if ((Array.isArray(imagesToDisplay) && imagesToDisplay.length === 0) || !imagesToDisplay) {
    imagesToDisplay = getSingleImageObj(uniqueId);
  }

  const iconConfig = {
    twitter: 'twitter-grey',
    pinterest: 'pinterest-grey',
    facebook: 'facebook-grey',
  };

  const getSocialConnectWidget = () => {
    return (
      <SocialConnect
        className="bundle-social-wrapper-redesign"
        isFacebookEnabled
        isPinterestEnabled
        isTwitterEnabled
        iconConfig={iconConfig}
        isBundlePageRedesign={isBundlePageRedesign}
      />
    );
  };

  const getProductSummary = () => {
    const prices = {
      highListPrice,
      highOfferPrice,
      listPrice: lowListPrice,
      offerPrice: lowOfferPrice,
      onlyListPrice: lowListPrice,
    };
    return (
      <Row fullBleed>
        <Col colSize={{ small: 6, medium: 8, large: 12 }} className="product-price-col">
          <div className="product-summary-wrapper-new-design">
            <div className="title-wrapper-new-design">{name}</div>
            {getSocialConnectWidget()}
          </div>
          <StyledPriceContainer
            currencyAttributes={currencyAttributes}
            isItemPartNumberVisible={false}
            itemPartNumber={uniqueId}
            {...prices}
            isOutfitPage={isOutfitPage}
            errorMessages={errorMessages}
            isHideOriginalPrice={isHideOriginalPrice}
            isBundlePageRedesign={isBundlePageRedesign}
          />
          <LoaderSkelton className="plcc-wrapper" />
        </Col>
      </Row>
    );
  };

  const styledList = () => {
    return (
      <BundleProductListLoaderContext.Provider value={bundleProductsLength}>
        <BundleProductListLoadingComponent />
      </BundleProductListLoaderContext.Provider>
    );
  };
  const getBundleProductsGrid = () => {
    return (
      <Row>
        <Col colSize={{ small: 6, medium: 8, large: 12 }} className={'plp-grid'}>
          {bundleProductGridComponent(bundleProductsLength)}
        </Col>
      </Row>
    );
  };

  const renderCurrentView = () => {
    return currentView === 'grid' ? (
      <Row className="bundle-product-grid-skeleton">{getBundleProductsGrid()}</Row>
    ) : (
      <Row className="bundle-product-list-container">{styledList()}</Row>
    );
  };
  const combinedKit = currentProduct?.kitGrouping || [1, 2, 3, 4, 5, 6, 7, 8, 9];

  return (
    <div className={className}>
      {breadcrumb()}
      <Row fullBleed className="product-detail-skeleton-wrapper">
        <Col colSize={{ small: 6, medium: 8, large: 12 }}>
          {topPromos && topPromos.length > 0 && <PromoPDPBanners promos={topPromos} />}
        </Col>

        <Col colSize={{ small: 6, medium: 3, large: 4 }} className="main-bundle-image">
          {fromPLPPage ? (
            <ProductDetailImage
              className="outfit-carousal-skeleton-image"
              imageUrl={imagesToDisplay?.[0]?.bigSizeImageUrl}
              imageName={currentProduct?.name}
              isZoomEnabled={false}
              imageConfig={IMG_DATA?.imgConfig}
              isOutfitPage={false}
              primaryBrand={primaryBrand}
              fromPLPPage={false}
              isFromBundlePage
              imageConfigWithoutDPR={imageConfigWithoutDPR}
            />
          ) : (
            <ProductDetailImage
              className="outfit-carousal-image"
              imageUrl={imagesToDisplay?.[0]?.bigSizeImageUrl}
              imageName={currentProduct?.name}
              isZoomEnabled={false}
              imageConfig={IMG_DATA?.imgConfig}
              isOutfitPage={false}
              primaryBrand={primaryBrand}
              fromPLPPage={fromPLPPage}
              isFromBundlePage
              imageConfigWithoutDPR={imageConfigWithoutDPR}
            />
          )}
        </Col>
        <Col colSize={{ small: 6, medium: 4, large: 7 }} className={'main-bundle-description'}>
          {isCombinedKitsEnabled && (
            <div className="combined-kits-wrapper-skeleton hide-on-desktop hide-on-tablet">
              <LoaderSkelton height={'21px'} width="250px" />
              <div className="combined-kit-skeleton">
                {[1, 2, 3, 4, 5].map((item) => {
                  return <LoaderSkelton key={item} className="loader-skeleton-kit" />;
                })}
              </div>
            </div>
          )}
          {getProductSummary()}
          <LoaderSkelton className="product-skeleton-description" />
          {isCombinedKitsEnabled && (
            <div className="combined-kits-wrapper-skeleton hide-on-mobile">
              <LoaderSkelton height={'21px'} width="250px" />
              <div className="combined-kit-skeleton">
                {combinedKit.map((item) => {
                  return <LoaderSkelton key={item} className="loader-skeleton-kit" />;
                })}
              </div>
            </div>
          )}
        </Col>
      </Row>
      <StyledLoaderSkeleton className="switch-skeleton" />
      {renderCurrentView()}
    </div>
  );
};

BundleProductSkeletonNewDesign.propTypes = {
  className: PropTypes.string.isRequired,
};

export default withStyles(BundleProductSkeletonNewDesign, styles);
export { BundleProductSkeletonNewDesign as BundleProductSkeletonNewDesignVanilla };
